export function isDefinedNumber(value){
    return value || value === 0;
}

export function containsHtmlTags(input) {
    // Regex to detect HTML tags
    const htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
    return htmlTagPattern.test(input);
}